// libs
import { memo } from "react";
import styled from "@emotion/styled";

// styles
const Message = styled.div<{ isError?: boolean }>`
    margin-top: 10px;
    min-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.07rem;
    text-align: center;

    ${({ isError = false }) =>
        isError &&
        `
        color: #ff0000;
    `}
`;

export default memo(Message);
